import React from 'react';
import { Link } from 'react-router-dom';
import {BsArrowRight} from 'react-icons/bs';
import { ImageUrl } from '../../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const CreateOwnDiamond = () => {
  return (
    <>
        <section className='create_own_diamond_ring'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 align-self-center'>
                        <div className='right-content'>
                            <h2>Create your Own Diamond Ring</h2>
                            <LazyLoadImage className='d-md-none d-block' src={`${ImageUrl}theme/newyork/Slider/setting.png`} alt="" />
                            <p>Select a setting and choose a diamond to create your own diamond engagement ring.</p>
                            <p className='mb-2'><strong>Need help?</strong> We're always here</p>
                            
                            <div className='btn-groups d-flex flex-column justify-content-start'>
                                <Link to="/engagement-rings" className='btn outline-btn'>Start with a setting <BsArrowRight /></Link>
                                <Link to="/diamonds" className='btn outline-btn'>Start with a Diamond <BsArrowRight /></Link>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-6 col-md-6 text-center d-md-block d-none'>
                        <LazyLoadImage className='' src={`${ImageUrl}theme/newyork/Slider/setting.png`} alt="" />
                    </div>
                </div>
            </div>
        </section>
    </>

  )
}

export default CreateOwnDiamond;